import { notify } from "../../event-bus";
import Vue from "vue";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    game: {},
    me: {
      playedCard: null,
      took: 0
    },
    lastHand: {},
    players: [],
    cards: [],
  },
  getters: {
    game: (state) => {
      return state.game;
    },
    players: (state) => {
      return state.players;
    },
    cards: (state) => {
      return state.cards;
    },
    isMyTurn: (state) => {
      return state.players[0].is_user_turn;
    },
    myPlayedCard: (state) => {
      return state.players[0].played_card;
    },
    hasTook: (state) => {
      return state.me.took;
    },
    lastHand: (state) => {
      return state.lastHand;
    },
  },

  actions: {
    startGame({ dispatch }, payload) {
      return Vue.http
        .post(`${process.env.VUE_APP_BACKEND_APP}/api/games`, payload, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Socket-Id": window.Echo.socketId(),
          },
        })
        .then((response) => {
          if (response.status == 201) {
            const data = {
              tableId: response.data.game.table_id,
              id: response.data.game.id,
            };
            dispatch("retrieveGameData", data);
          }
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
    retrieveGameData({ commit, dispatch }, payload) {
      return Vue.http
        .get(
          `${process.env.VUE_APP_BACKEND_APP}/api/games/${payload.id}`,
          {},
          {
            headers: {
              "X-Socket-Id": window.Echo.socketId(),
            },
          }
        )
        .then((response) => {
          commit("gameData", response.data.data);
          if (router.currentRoute.name !== "game") {
            router.push("/game");
          }
          dispatch("takeCards");
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
    takeCards({ commit }) {
      return Vue.http
        .get(
          `${process.env.VUE_APP_BACKEND_APP}/api/games/${this.state.game.game.id}/users/${this.state.user.user.id}`,
          {
            withCredentials: true,
            headers: {
              "X-Socket-Id": window.Echo.socketId(),
            },
          }
        )
        .then((response) => {
          response.data.cards.forEach(function(card, index) {
            setTimeout(() => {
              commit("addCard", card);
            }, index * 400);
          });
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
    unlockGame({ commit }, payload) {
      return Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/games/${payload.gameId}/unlock`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Socket-Id": window.Echo.socketId(),
            },
          }
        )
        .then(() => {
          commit("unlock", { userId: payload.userId });
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
  },
  mutations: {
    gameData(state, gameData) {
      this.state.showHeader = false;
      state.game = gameData;
      state.me.took = 0;
      gameData.users.map((player) =>
        player.took = 0
      );
      state.players = [];
      function nextUser(user) {
        let pos = user.user_position + 1;
        return gameData.users.filter(
          (user) => user.user_position == (pos <= 5 ? pos : pos - 5)
        )[0];
      }
      let next = gameData.users.filter(
        (user) => user.id == this.state.user.user.id
      )[0];
      state.players.push(next);
      next = nextUser(next);
      state.players.push(next);
      next = nextUser(next);
      state.players.push(next);
      next = nextUser(next);
      state.players.push(next);
      next = nextUser(next);
      state.players.push(next);
    },
    addCard(state, card) {
      state.cards.push(card);
    },
    updateGameData(state, gameData) {
      state.game = gameData;
    },
    cardPlayed(state, payload) {
      if (this.state.audio) {
        var audio = new Audio(
          require("../../assets/audio/play-card.mp3")
        );
        audio.play();
      }
      state.players.map((player) =>
        player.id == payload.userId
          ? (player.played_card = payload.card)
          : player
      );
    },
    setMyCards(state, payload) {
      state.cards = payload;
    },
    setCardOnTable(state, payload) {
      state.players[0].played_card = payload.card;
    },
    updateUserTurn(state, nextUser) {
      state.players.map((player) =>
        player.id == nextUser
          ? (player.is_user_turn = true)
          : (player.is_user_turn = false)
      );
    },
    updateUserTook(state, userId) {
      state.players.map((player) =>
        player.id == userId ? (player.took = 1) : player
      );
      if(userId == this.state.user.user.id) {
        state.me.took = 1;
      }
    },
    resetPlayedCard(state) {
      state.players.forEach((player) => (
        player.previous_card = player.played_card,
        player.played_card = null
      ));
    },
    resetCards(state) {
      state.cards = [];
    },
    exit(state) {
      state;
      this.state.showHeader = true;
      state.game = {};
      state.players = [];
      state.cards = [];
    },
    unlock(state, payload) {
      state.players.map((player) =>
        player.id == payload.userId ? (player.is_locked = false) : player
      );
    },
    lastHand(state, payload) {
      var playerIndex = this.state.game.players.findIndex(
        (player) => player.id == payload.firstPlayerId
      );
      state.lastHand.players = this.state.game.players.slice();
      while (playerIndex > 0) {
        let player = state.lastHand.players.shift();
        state.lastHand.players.push(player);
        playerIndex = playerIndex - 1;
      }
      state.lastHand.winner = payload.handWinner;
    }
  },
};
